/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { format } from 'date-fns';
import { getUTCDateFromMilliseconds } from '../../../../shared/utils/smartutils';

export function columnsReceipts(t) {
  const textEllipsis = {
    maxWidth: '10rem',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };

  return [
    { title: t('general.code'), field: 'id' },
    {
      title: t('general.date'),
      field: 'payDay',
      render: (rowData) =>
        format(getUTCDateFromMilliseconds(rowData.payDay), 'dd/MM/yyyy'),
    },
    {
      title: t('general.discounts-fees'),
      field: 'discount',
      render: (rowData) =>
        rowData.discount.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        }),
    },
    {
      title: t('general.interest-fines'),
      field: 'additions',
      render: (rowData) =>
        rowData.additions.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        }),
    },
    {
      title: t('general.amount-received'),
      field: 'amountPayment',
      render: (rowData) =>
        rowData.amountPayment.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        }),
    },
    {
      title: t('general.note'),
      field: 'obs',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.obs}>
          {rowData.obs}
        </span>
      ),
    },
  ];
}

export function columnsItems(t) {
  return [
    { title: t('general.category'), field: 'category.name' },
    { title: t('general.quota'), field: 'quota' },
    {
      title: t('general.value'),
      field: 'value',
      render: (rowData) =>
        rowData.value.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        }),
    },
  ];
}
